<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">{{ props.data?.title }}</li>
      <el-button
        type="primary"
        :icon="Upload"
        size="small"
        link
        @click="onExport"
        v-if="$judge_auth('779')"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <div>
        <li
          style="
            margin-top: -20px;
            margin-left: -10px;
            margin-bottom: 5px;
            padding: 0 10px;
            font-size: 11px;
            color: #a2a2a2;
            background-color: #fff;
            width: fit-content;
          "
        >
          汇算清缴状态
        </li>
        <c_statusradiogroup
          v-model="state.params.zt"
          arrName="taxfinalsettlement_detail_zt"
          @change="onLoad"
        ></c_statusradiogroup>
      </div>
      <div>
        <li
          style="
            margin-top: -20px;
            margin-left: -10px;
            margin-bottom: 5px;
            padding: 0 10px;
            font-size: 11px;
            color: #a2a2a2;
            background-color: #fff;
            width: fit-content;
          "
        >
          申报状态
        </li>

        <c_statusradiogroup
          v-model="state.params.sbzt"
          arrName="taxfinalsettlement_detail_sbzt"
          @change="onLoad"
        ></c_statusradiogroup>
      </div>
      <div>
        <li
          style="
            margin-top: -20px;
            margin-left: -10px;
            margin-bottom: 5px;
            padding: 0 10px;
            font-size: 11px;
            color: #a2a2a2;
            background-color: #fff;
            width: fit-content;
          "
        >
          退补税类型
        </li>
        <c_statusradiogroup
          v-model="state.params.tbslx"
          arrName="taxfinalsettlement_detail_tbslx"
          @change="onLoad"
        ></c_statusradiogroup>
      </div>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="扣缴义务人"
          prop="withholding_agent_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="姓名" prop="xm" :formatter="$tab_TextFormat" />
        <el-table-column
          label="证件类型"
          prop="zzlx"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="证件号码"
          prop="zzhm"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="手机号码"
          prop="lxdh"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="人员状态"
          prop="nsrzt"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="申报状态"
          prop="sbzt_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="汇算清缴状态"
          prop="zt_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="失败原因"
          prop="sbyy"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="退补税类型"
          prop="tbslx_name"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="受雇类型"
          prop="sfgy"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="入职日期"
          prop="rzsgrq"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="离职日期"
          prop="lzrq"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="更新时间"
          prop="update_time"
          :formatter="$tab_TextFormat"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  taxfinalsettlement_detail,
  taxfinalsettlement_export,
} from "@/http/taxfinalsettlement";
import { dayjs, ElMessage } from "element-plus";
import { income_select } from "@/http/dictionary";
import { data_customer_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
      tableData: [],
    });
    onMounted(() => {
      state.params.tax_final_settlement_id = props.data?.id;
      onLoadIncome();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      taxfinalsettlement_detail(state.params)
        .then((res) => {
          if (res.status == 200) {
            const { count, list, sortFields } = res.data.data;
            state.totalCount = count;
            state.tableData = list;
            state.sortFields = sortFields;
          } else {
            state.totalCount = 0;
            state.tableData = [];
            ElMessage.error(res.data.msg);
          }
        })
        .catch((err) => {
          state.totalCount = 0;
          state.tableData = [];
          ElMessage.error(err.data.msg);
        });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");
      onLoad();
    };

    //获取所得项目
    const onLoadIncome = () => {
      income_select().then((res) => {
        if (res.status == 200) state.incomeData = res.data.data;
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxfinalsettlement_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
      onExport,
      onLoadIncome,
      onLoadCustomer,
    };
  },
};
</script>
<style scoped></style>
